/**
 * Delivery Deadlines shared constants (kept out of OrderService so DeliveryScheduleService can
 * import them without pulling in the order module).
 */

/** Upper bound on how many upcoming delivery dates a schedule may offer at checkout. */
export const MAX_CUSTOMER_DELIVERY_DAY_OPTIONS = 8;

/**
 * Timezone used when neither the vendor nor the supplier has one. The UI"s
 * DEFAULT_DELIVERY_TIMEZONE must match so the preview never computes a different cutoff than
 * the server stamps on submit.
 */
export const DEFAULT_DELIVERY_TZ = "America/New_York";
